<ion-content [fullscreen]="true" class="map-container">
  <div #mapElement id="map" class="google-map"></div>
</ion-content>